export default "__VITE_ASSET__BXF5hQ_8__"